import { render, staticRenderFns } from "./Pricelist.vue?vue&type=template&id=2477c6aa&scoped=true&"
import script from "./Pricelist.vue?vue&type=script&lang=js&"
export * from "./Pricelist.vue?vue&type=script&lang=js&"
import style0 from "./Pricelist.vue?vue&type=style&index=0&id=2477c6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477c6aa",
  null
  
)

export default component.exports